module.exports = __webpack_public_path__ + "static/media/phone_1.16ddd2b6.png";